import clsx from "clsx";
import Link from "next/link";
import { useRouter } from "next/router";

export const NavLink = ({ name, path }: { name: string; path: string }) => {
  const router = useRouter();
  const active = router.pathname === path;

  return (
    <Link
      key={name}
      href={path}
      className={clsx(
        active ? "text-white" : "text-gray-500",
        "rounded-md py-2 px-3 font-medium"
      )}
      aria-current={active ? "page" : undefined}
    >
      {name}
    </Link>
  );
};
